const defaultstate = { passwords: [], loading: false, error: false }

export default function (state = defaultstate, action) {
    switch (action.type) {
        case 'fetch_password_loading':
            return {
                ...state.state,
                loading: true
            };
        case 'fetch_password_success':
            return {
                ...state.state,
                passwords: action.payload,
                loading: false
            };
        case 'fetch_password_error':
            return {
                ...state.state,
                loading: false,
                error: true
            };

        default:
            return state
            
    }
}